(function () {
  'use strict';

  if (customElements.get('product-reviews-modal')) return;

  /**
   * <product-reviews-modal>
   * "See all N reviews" button + scrollable <dialog> with every review.
   * Esc / backdrop / close button dismiss; focus returns to the trigger.
   *
   * The body scroll unlock runs in every close path directly (button,
   * backdrop, Esc via 'cancel') as well as on 'close' — some embedded
   * browsers don't deliver the dialog 'close' event reliably.
   */
  class ProductReviewsModal extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-reviews-open]');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog) return;

      this.onOpen = this.onOpen.bind(this);
      this.onClosed = this.onClosed.bind(this);
      this.onBackdrop = this.onBackdrop.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);

      this.trigger.addEventListener('click', this.onOpen);
      this.dialog.addEventListener('click', this.onBackdrop);
      this.dialog.addEventListener('close', this.onClosed);
      this.dialog.addEventListener('cancel', this.onClosed);
      this.closeBtn = this.querySelector('[data-reviews-close]');
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.onCloseClick);
    }

    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener('click', this.onOpen);
      if (this.dialog) {
        this.dialog.removeEventListener('click', this.onBackdrop);
        this.dialog.removeEventListener('close', this.onClosed);
        this.dialog.removeEventListener('cancel', this.onClosed);
      }
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onCloseClick);
    }

    onOpen() {
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
    }

    onClosed() {
      document.body.style.overflow = '';
      if (this.trigger) this.trigger.focus();
    }

    onCloseClick() {
      this.dialog.close();
      this.onClosed();
    }

    onBackdrop(event) {
      if (event.target === this.dialog) {
        this.dialog.close();
        this.onClosed();
      }
    }
  }

  customElements.define('product-reviews-modal', ProductReviewsModal);
})();

/* Review rail "Read more" toggle (button rendered by product-review-card for long texts). */
(function () {
  'use strict';

  if (window.productReviewsMoreBound) return;
  window.productReviewsMoreBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-review-more]');
    if (!button) return;
    var card = button.closest('.product-reviews__rail-card');
    if (!card) return;
    if (!button.dataset.labelMore) button.dataset.labelMore = button.textContent.trim();
    var open = card.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.textContent = open ? button.dataset.labelLess || 'Show less' : button.dataset.labelMore;
  });
})();
